import * as React from "react";
import DirectorySidebar from "./DirectorySidebar";
class Directories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(DirectorySidebar, null), /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex align-items-center" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "p-2 col-example",
        style: {
          textAlign: "center",
          marginLeft: "100px",
          marginRight: "100px",
          width: "60%"
        }
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-folder-open", size: "6x" }),
      /* @__PURE__ */ React.createElement("h2", { style: { fontWeight: "bolder", fontStyle: "italic" } }, "Upload Directories")
    ))));
  }
}
export default Directories;
